import React from "react";

export const CrossIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.1554 9.99944L17.0148 3.01507C17.113 2.899 17.0304 2.72266 16.8786 2.72266H15.0974C14.9925 2.72266 14.892 2.76953 14.8228 2.84989L9.99024 8.61105L5.15765 2.84989C5.09069 2.76953 4.99024 2.72266 4.8831 2.72266H3.10185C2.95006 2.72266 2.86747 2.899 2.96569 3.01507L8.82506 9.99944L2.96569 16.9838C2.94368 17.0097 2.92957 17.0413 2.92502 17.075C2.92046 17.1086 2.92566 17.1429 2.94 17.1737C2.95434 17.2045 2.97721 17.2305 3.0059 17.2487C3.03458 17.2669 3.06788 17.2764 3.10185 17.2762H4.8831C4.98801 17.2762 5.08845 17.2294 5.15765 17.149L9.99024 11.3878L14.8228 17.149C14.8898 17.2294 14.9902 17.2762 15.0974 17.2762H16.8786C17.0304 17.2762 17.113 17.0999 17.0148 16.9838L11.1554 9.99944Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const BarsIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.4994 2.56641H1.49944C1.38158 2.56641 1.28516 2.66283 1.28516 2.78069V4.49498C1.28516 4.61284 1.38158 4.70926 1.49944 4.70926H22.4994C22.6173 4.70926 22.7137 4.61284 22.7137 4.49498V2.78069C22.7137 2.66283 22.6173 2.56641 22.4994 2.56641ZM22.4994 19.2807H1.49944C1.38158 19.2807 1.28516 19.3771 1.28516 19.495V21.2093C1.28516 21.3271 1.38158 21.4236 1.49944 21.4236H22.4994C22.6173 21.4236 22.7137 21.3271 22.7137 21.2093V19.495C22.7137 19.3771 22.6173 19.2807 22.4994 19.2807ZM22.4994 10.9236H1.49944C1.38158 10.9236 1.28516 11.02 1.28516 11.1378V12.8521C1.28516 12.97 1.38158 13.0664 1.49944 13.0664H22.4994C22.6173 13.0664 22.7137 12.97 22.7137 12.8521V11.1378C22.7137 11.02 22.6173 10.9236 22.4994 10.9236Z"
        fill="currentColor"
        fillOpacity="0.85"
      />
    </svg>
  );
};

export const CloseIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.1552 9.99944L17.0145 3.01507C17.1128 2.899 17.0302 2.72266 16.8784 2.72266H15.0971C14.9922 2.72266 14.8918 2.76953 14.8226 2.84989L9.99 8.61105L5.15741 2.84989C5.09044 2.76953 4.98999 2.72266 4.88285 2.72266H3.1016C2.94982 2.72266 2.86723 2.899 2.96544 3.01507L8.82482 9.99944L2.96544 16.9838C2.94344 17.0097 2.92933 17.0413 2.92477 17.075C2.92022 17.1086 2.92542 17.1429 2.93976 17.1737C2.95409 17.2045 2.97696 17.2305 3.00565 17.2487C3.03434 17.2669 3.06764 17.2764 3.1016 17.2762H4.88285C4.98776 17.2762 5.08821 17.2294 5.15741 17.149L9.99 11.3878L14.8226 17.149C14.8895 17.2294 14.99 17.2762 15.0971 17.2762H16.8784C17.0302 17.2762 17.1128 17.0999 17.0145 16.9838L11.1552 9.99944Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const CaretIcon = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.39777 5.66233L3.36027 0.9467C3.34449 0.93428 3.32553 0.926562 3.30557 0.924431C3.2856 0.9223 3.26544 0.925844 3.2474 0.934655C3.22936 0.943466 3.21417 0.957188 3.20357 0.974243C3.19298 0.991299 3.18741 1.011 3.1875 1.03108V2.06634C3.1875 2.13197 3.2183 2.19491 3.2692 2.23509L8.09063 5.99983L3.2692 9.76456C3.21697 9.80474 3.1875 9.86768 3.1875 9.93331V10.9686C3.1875 11.0583 3.29063 11.1079 3.36027 11.053L9.39777 6.33733C9.44908 6.2973 9.4906 6.2461 9.51915 6.18761C9.5477 6.12913 9.56254 6.06491 9.56254 5.99983C9.56254 5.93475 9.5477 5.87052 9.51915 5.81204C9.4906 5.75356 9.44908 5.70235 9.39777 5.66233Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const InfoCircleIcon = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 0C2.68661 0 0 2.68661 0 6C0 9.31339 2.68661 12 6 12C9.31339 12 12 9.31339 12 6C12 2.68661 9.31339 0 6 0ZM6 10.9821C3.24911 10.9821 1.01786 8.75089 1.01786 6C1.01786 3.24911 3.24911 1.01786 6 1.01786C8.75089 1.01786 10.9821 3.24911 10.9821 6C10.9821 8.75089 8.75089 10.9821 6 10.9821Z"
        fill="currentColor"
      />
      <path
        d="M5.35693 3.64286C5.35693 3.81335 5.42466 3.97687 5.54522 4.09743C5.66578 4.21799 5.82929 4.28571 5.99979 4.28571C6.17029 4.28571 6.3338 4.21799 6.45436 4.09743C6.57492 3.97687 6.64265 3.81335 6.64265 3.64286C6.64265 3.47236 6.57492 3.30885 6.45436 3.18829C6.3338 3.06773 6.17029 3 5.99979 3C5.82929 3 5.66578 3.06773 5.54522 3.18829C5.42466 3.30885 5.35693 3.47236 5.35693 3.64286ZM6.32122 5.14286H5.67836C5.61943 5.14286 5.57122 5.19107 5.57122 5.25V8.89286C5.57122 8.95179 5.61943 9 5.67836 9H6.32122C6.38015 9 6.42836 8.95179 6.42836 8.89286V5.25C6.42836 5.19107 6.38015 5.14286 6.32122 5.14286Z"
        fill="currentColor"
      />
    </svg>
  );
};
